import React, { ReactNode } from "react";
import { Dimensions } from "./Dimensions";
import { CELL_SIZE } from "./constants";
import { createArray } from "src/arrays/createArray";
import { observer } from "mobx-react-lite";

export const Grid = observer(function Grid<T extends ReactNode>({
  dimensions,
  renderCell,
}: {
  dimensions: Dimensions;
  renderCell: (index: number) => T;
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `${CELL_SIZE}px `.repeat(dimensions.width),
      }}
    >
      {createArray(dimensions.height * dimensions.width, (index) =>
        renderCell(index)
      )}
    </div>
  );
});
